import React, { Component } from 'react';
import { func } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getDailyConditions as getDailyConditionsByFieldId,
  getDailyConditionsByLocation,
} from '../actions/weatherForecastActions';
import { DailyForecast } from '../components/DailyForecast';
import { FieldType, WeatherConditionsType } from '../types';

class DailyForecastContainer extends Component {
  componentDidMount() {
    const { getDailyConditions: getDailyConditionsProp, field } = this.props;

    getDailyConditionsProp(field);
  }

  componentDidUpdate(prevProps) {
    const { getDailyConditions: getDailyConditionsProp, field } = this.props;

    if (prevProps.field.id !== field.id) {
      getDailyConditionsProp(field);
    }
  }

  render() {
    const { dailyConditions } = this.props;

    return (
      <div>
        {dailyConditions.firstForecastTime ? (
          <DailyForecast dailyConditions={dailyConditions} />
        ) : null}
      </div>
    );
  }
}

DailyForecastContainer.propTypes = {
  dailyConditions: WeatherConditionsType,
  field: FieldType,
  getDailyConditions: func.isRequired,
};

function mapStateToProps(state) {
  return {
    field: state.field,
    dailyConditions: state.weatherForecast.dailyConditions,
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  const { isMicrosoftWxFeatureAvailable } = ownProps;
  const getDailyConditions = isMicrosoftWxFeatureAvailable
    ? getDailyConditionsByLocation
    : getDailyConditionsByFieldId;

  return bindActionCreators(
    {
      getDailyConditions,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DailyForecastContainer);
